import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { Box, CircularProgress, ThemeProvider } from "@mui/material";
import Header from "src/components/header/header";
import theme from "src/styles/mainstyle";
import Footer from "src/components/footer/footer";
import ContentBox from "src/components/ContentBox/ContentBox";
import NotFoundPage from "./MainPage/Components/NotFound";

// Webpack: require all .md files in ../press-releases
const req = require.context("../media/press-releases", true, /\.md$/);

export default function PressRelease() {
  const { slug, lang } = useParams();
  const [content, setContent] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    if (!slug) return;
    const fileName = `./${slug}/${lang || "eng"}.md`;
    if (req.keys().includes(fileName)) {
      setContent(undefined);
      const file = req(fileName);
      fetch((file as string) || (file as { default: string }).default)
        .then((res) => res.text())
        .then(setContent)
        .catch(() => setContent(null));
    } else {
      setContent(null);
    }
  }, [slug, lang]);

  if (content === null) return <NotFoundPage />;
  if (content === undefined) return <CircularProgress />;

  // Find available languages for this article
  const availableLangs = req
    .keys()
    .filter((key) => key.startsWith(`./${slug}/`))
    .map((key) => key.split("/")[2].replace(".md", ""));

  return (
    <>
      <ThemeProvider theme={theme}>
        <Header />
        <Box sx={{ p: 3 }} />
        <ContentBox>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              p: 2,
            }}
          ></Box>
          <Box sx={{ textAlign: "center" }}>
            <ReactMarkdown
              components={{
                img: ({ node, ...props }) => (
                  <img
                    {...props}
                    style={{
                      width: "auto",
                      maxWidth: "60vw",
                      height: "auto",
                      maxHeight: "40vh",
                      objectFit: "contain",
                      display: "block",
                      margin: "24px auto",
                      borderRadius: 8,
                      // boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    }}
                    alt={props.alt}
                  />
                ),
              }}
            >
              {content}
            </ReactMarkdown>
          </Box>
        </ContentBox>
        <Footer />
      </ThemeProvider>
    </>
  );
}
